module.exports = __webpack_public_path__ + "img/Stachelschwein.daa4c641.jpg";